import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { mergeMap, catchError } from 'rxjs/operators';
import { KeyingAuthService } from '../services/keying.auth.service';

@Injectable()
export class HttpClientInterceptor implements HttpInterceptor {
  constructor(private keyingAuthService: KeyingAuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.keyingAuthService.getTokenSilently$().pipe(
      mergeMap(token => {
        const tokenReq = req.clone({
          setHeaders: { Authorization: `Bearer ${token}` },
        });
        return next.handle(tokenReq);
      }),
      catchError(err => throwError(err))
    );
  }
}
